import { useMemo } from 'react';
import { isEqual } from 'lodash';
import { Store } from 'components/common/types/Store.types';
import { RouteFrameCode } from 'components/common/types/Deal.types';
import { FileList } from 'components/common/types';
import { isValueRequired } from '../../utils/isValueRequired';

export const useProductFrameListChangeDetection = (
  selectedPermission: { code: string },
  defaultSelectedPermission: { code: string },
  productFrameList: Store['productManagement']['newProduct']['frameList'],
  initialRouteFrameCodes: RouteFrameCode[],
  selectedRouteFrameCodes: RouteFrameCode[],
  initialListFiles: FileList[],
  uploadedListOfFiles: FileList[],
): { hasPermissionOrFrameListSelectionChanges: boolean; hasFrameListSelectionChanges: boolean } => {
  const hasFrameListSelectionChanges = useMemo(() => {
    const routeFrameCodesChanged = !isEqual(initialRouteFrameCodes, selectedRouteFrameCodes);
    const listFilesChanged = !isEqual(initialListFiles, uploadedListOfFiles);
    return routeFrameCodesChanged || listFilesChanged;
  }, [initialRouteFrameCodes, selectedRouteFrameCodes, initialListFiles, uploadedListOfFiles]);

  const hasPermissionOrFrameListSelectionChanges = useMemo(() => {
    const permissionChanged = selectedPermission.code !== defaultSelectedPermission.code;
    const valueRequired = isValueRequired(selectedPermission.code);
    const hasExistingValue = !!productFrameList?.value;

    if (!hasExistingValue) {
      return valueRequired ? permissionChanged || hasFrameListSelectionChanges : permissionChanged;
    }

    if (permissionChanged) {
      return true;
    }

    return valueRequired ? hasFrameListSelectionChanges : false;
  }, [selectedPermission.code, defaultSelectedPermission.code, productFrameList?.value, hasFrameListSelectionChanges]);

  return { hasPermissionOrFrameListSelectionChanges, hasFrameListSelectionChanges };
};
